"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSupplierPrice = void 0;
/**
 * Allows you to completely remove a supplier price from the database.
 */
var deleteSupplierPrice = function (instance) {
    return function (ref, sku, postcode, config) {
        return instance.delete("/catalogues/supplier-prices/".concat(ref, "/").concat(sku, "/").concat(postcode), config);
    };
};
exports.deleteSupplierPrice = deleteSupplierPrice;
